import { t } from "@/i18n-js/instance";
import { formatPaywallCurrencyAmount } from "@/react/helpers/paywalls/currencies";
import { mapCurrencyAmountStrToInt } from "@circle-react/components/Paywalls/Admin/utils";
import { paywallPriceTypes } from "@circle-react/types/PaywallPrice";
import type {
  NoticeScenario,
  NoticeScenarioMatcher,
  NoticeScenarioMessagePropsResolver,
} from "../NoticeScenario.types";
import { localeRoot } from "../constants";
import { recurringStateValidator } from "./StateValidators";

const matcher: NoticeScenarioMatcher = ({
  priceType,
  hasUpfrontPayment,
  hasTrialPeriod,
  isUpfrontPaymentRequiredForTrial,
}) =>
  priceType === paywallPriceTypes.subscription &&
  hasUpfrontPayment &&
  hasTrialPeriod &&
  !isUpfrontPaymentRequiredForTrial;
const messagePropsResolver: NoticeScenarioMessagePropsResolver = ({
  buildOptions,
  currency,
  trialPeriodDays,
  watch,
}) => {
  // Locale variables
  const member_free_trial_phrase = t(
    [localeRoot, "phrases", "member_free_trial"],
    {
      count: trialPeriodDays,
    },
  );

  const then_upfront_amount_phrase = t(
    [localeRoot, "phrases", "then_upfront_amount"],
    {
      amount: formatPaywallCurrencyAmount(
        currency,
        mapCurrencyAmountStrToInt(watch("upfront_payment_amount")),
      ),
    },
  );

  return [
    ["trial_then_upfront_then_subscription"],
    {
      member_free_trial_phrase,
      then_upfront_amount_phrase,
      recurring_amount: formatPaywallCurrencyAmount(
        currency,
        mapCurrencyAmountStrToInt(watch("amount")),
      ),
      recurring_frequency:
        buildOptions.frequencies[
          watch("billing_frequency")
        ].as_phrase.toLowerCase(),
    },
  ];
};
export const trialThenUpfrontThenSubscription: NoticeScenario = {
  matcher,
  stateValidator: recurringStateValidator,
  messagePropsResolver,
};
